module.exports = __webpack_public_path__ + "img/20.61ab0f85.jpg";